import CategoriasHome from './categoriasHome';
import Testimonials from '../aboutUs/testimonials';
//import NewProduct from './newProduct';


function BodyUni() {
    return (
        <div>
            {/* banner img */}
            <div className='py-4'>
                <CategoriasHome />
            </div>
            {/*<div>
                <NewProduct />
            </div>*/}
            <Testimonials />
        </div>
    );
}

export default BodyUni;
